"use strict";import{IconCheckmarkCircle as e}from"../src/elements/IconCheckmarkCircle.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-checkmark-circle",e);
//# sourceMappingURL=sp-icon-checkmark-circle.js.map
